import styled from 'styled-components';
import { OutlinedButton } from 'styles/styles';

// eslint-disable-next-line import/prefer-default-export
export const SmallOutlinedButton = styled(OutlinedButton)`
  padding: 0.25rem 0.5rem;
`;
